import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { mapSetSchema } from '../schemas/map-set.schema';

/**
 * Gets Map Sets assigned to a specific Vehicle Group
 * @param vehicleGroupId Vehicle Group ID of group whose Map Sets are being requested
 * @returns Array of IDs
 */
export function getVehicleGroupsIdMapsets(
  this: unknown,
  vehicleGroupId: number
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .vehicleGroupsIdMapsetsUrl(String(vehicleGroupId)),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(z.array(mapSetSchema)));
}
